
import PreEntryApi from '../../assets/js/preentry'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
components: {
XButton,
Loading,
Flexbox,
FlexboxItem,
Alert,
Confirm,
OnboardHeader
},
data () {
return {
isErrorPage: false,
id: '',
name: '',
isZH: localStorage.getItem('offer_zh') === 'zh',
info_edu_status: 1,
info_work_status: 1,
info_train_status: 1,
info_family_status: 1,
info_upload_status: 1,
info_certify_status: 1,
qualification_status: 1,
info_qualification_status: 1,
info_material_status: 1,
info_supplement_status: 1,
medical_status: 1,
certify_status: 1,
certify_memo: '',
medical_memo: '',
showLoading: true,
showError: false,
subMitConfirm: false,
is_intern: '',
job_type: '',
no_working: '',
name_pinyin: '',
surname_pinyin: '',
errMsg: '',
code: '',
isShowCertify: true,
country_id: ''
}
},
created () {
this.$forceUpdate()
this.id = this.$route.query.id


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
data => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

this.showLoading = true
try {
PreEntryApi.getSubmitStatus({ id: this.id }, data => {
if (data) {
this.is_intern = data.is_intern
this.job_type = data.job_type
this.no_working = data.no_working
this.is_blue_collar = data.is_blue_collar
this.no_certificate = data.no_certificate
if ((this.is_intern === 1 || this.no_working === 2) && this.job_type === 2) {
this.isShowCertify = false
}
}
})

PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
this.name = data.name
this.is_intern = data.is_intern
this.job_type = data.job_type
this.name_pinyin = data.name_pinyin
this.surname_pinyin = data.surname_pinyin
console.log(data)
}
}, err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
})

PreEntryApi.getStatusValue(
{ id: this.id, code: this.code },
data => {
if (data) {
this.info_edu_status = data.info_edu_status
this.info_work_status = data.info_work_status
this.info_train_status = data.info_train_status
this.info_family_status = data.info_family_status
this.info_upload_status = data.info_upload_status
this.info_certify_status = data.info_certify_status
this.qualification_status = data.qualification_status
this.info_qualification_status = data.info_qualification_status
this.info_material_status = data.info_material_status
this.info_supplement_status = data.info_supplement_status
this.certify_status = data.certify_status
this.medical_status = data.medical_status
this.certify_memo = data.certify_memo
this.medical_memo = data.medical_memo
this.country_id = data.country_id
if (data.no_working === 2) {
this.info_work_status = 3
}
if (data.no_training === 2) {
this.info_train_status = 3
}
if (this.country_id !== '47206' && data.no_family === 2) {
this.info_family_status = 3
}
}
this.showLoading = false
},
() => {
this.showLoading = false
},
() => {
this.showLoading = false
}
)
} catch (e) {
this.$message.error(this.$tsg('系统内部错误。'))
this.showLoading = false
return false
}
},
methods: {
goSubmit () {
this.subMitConfirm = true
},
goPreView () {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })
},
goSuccess () {
this.errMsg = ''
var msg =
'<div style="font-size:14px;color:red;text-align:left;">' +
this.$tsg('请完善') +
'：<br/><div style="text-indent:24px;">'
if (this.info_material_status !== 3) {
this.errMsg += this.$tsg('基本信息') + ','
}

if (this.info_edu_status !== 3) {
this.errMsg += this.$tsg('教育经历') + ','
}

if (this.info_family_status !== 3) {
this.errMsg += this.$tsg('家庭情况') + ','
}

if (this.info_work_status !== 3) {
this.errMsg += this.$tsg('工作经历') + ','
}

if (this.info_train_status !== 3) {
this.errMsg += this.$tsg('培训经历') + ','
}

if (this.info_upload_status !== 3) {
this.errMsg += this.$tsg('附件证明') + ','
}

if (this.info_supplement_status !== 3) {
this.errMsg += this.$tsg('其他信息') + ','
}

if (this.info_qualification_status !== 3) {
this.errMsg += this.$tsg('资格证书') + ','
}

if (this.info_certify_status !== 3 && this.isShowCertify === true) {
this.errMsg += this.$tsg('入职必备') + ','
}

if (this.errMsg) {
this.errMsg = this.errMsg.substr(0, this.errMsg.length - 1)
this.errMsg = msg + this.errMsg + '；<br/> ' + this.$tsg('然后提交') + '。</div></div>'
this.showError = true
return false
}

PreEntryApi.updateSubmitAt(
{ id: this.id, code: this.code },
data => {
if (data === '') {
this.$router.push({
name: 'onboard.preview',
query: { id: this.id }
})
}
},
(err, message) => {
this.errMsg = message
this.showError = true
return false
}
)
},
goTo (route) {
var name = 'onboard.' + route
this.$router.push({ name: name, query: { id: this.id } })
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/list.vue